import React, { useEffect, useState, useCallback, useRef } from 'react';

import style from './navigation.module.sass';
import * as _ from 'lodash';
import { Http } from '../../helpers/axois';
import { formPreview, formSave, HeaderData, DeploymentUpdateVerison, ThemeReload, ResourceLock } from "../../helpers/RxServices";
import { Button, Modal } from '../../helpers/commonUi'
import {Button as AntButton, Tag} from 'antd';

import OrgList from "./OrgList";

import { ReactComponent as MoreIcon } from "../../assets/images/form_icons/moreIcon.svg"
import duplicate from "../../assets/images/form_icons/MoreOptionsIcons/duplicateIcon.svg"
import deleteIcon from "../../assets/images/form_icons/MoreOptionsIcons/deleteIcon.svg"
import editIcon from "../../assets/images/form_icons/MoreOptionsIcons/editIcon.svg"
import settingIcons from "../../assets/images/form_icons/MoreOptionsIcons/settingIcons.svg"
import DuplicateFormModal from '../../pages/apps/Assisted/forms/create/headerOptions/DuplicateFormModal'
import { formPreviewType } from "../../helpers/RxServiceTypes";
import ImportWidget from '../marketplace/widgets/importWidget/ImportWidget'
import { FormPropertiesModal } from './FormProperties'
// import classNames from 'classnames';
import { Dropdown, Menu, Popover, Input } from 'antd';

import { ReactComponent as Undo } from '../../assets/svg/formUndo.svg'
import { ReactComponent as Redo } from '../../assets/svg/formRedo.svg'
import { ReactComponent as AppsIcon } from '../../assets/svg/sidemenu/apps.svg';
import { ReactComponent as EnvironmentIcon } from '../../assets/svg/sidemenu/environment.svg';
import { ReactComponent as AdminIcon } from '../../assets/svg/sidemenu/admin.svg';
import { ReactComponent as ThemeManagerIcon } from '../../assets/svg/sidemenu/themeManager.svg';
import { ReactComponent as DashboardIcon } from '../../assets/svg/sidemenu/dashboard.svg';
import { ReactComponent as OrgIcon } from '../../assets/svg/sidemenu/organization.svg';
import { ReactComponent as CaretDown } from '../../assets/svg/caretDown.svg'
import { ReactComponent as ThemeHeader } from '../../assets/svg/sidemenu/themeManager.svg'
import { ReactComponent as BackIcon } from '../../assets/svg/backButtonHeader.svg'
import { ReactComponent as BranchIcon } from '../../assets/svg/branch.svg'
import { ReactComponent as MarketplaceIcon } from '../../assets/svg/sidemenu/marketplace.svg'
import { ReactComponent as Import } from "../../assets/svg/MarketplaceFunctions/Vector.svg";
import privateIcon from "../../assets/svg/solo/private_col_ico.svg"
import publicIcon from "../../assets/svg/solo/public_col_ico.svg"
import undo from '../../assets/svg/undo.svg'
import soloIcon from "../../assets/svg/solo/solo_ico.svg"
import TarsIcon from "../../assets/images/tarsIcon.png";
import SoloChatBackIcon from "../../assets/svg/solo-chat/back.svg";
// import paste from '../../assets/svg/paste.svg'
// import copy from '../../assets/svg/copy.svg'
import unselected_redo from '../../assets/svg/unselect_Redo.svg'
import { Tooltip } from 'antd';
import { UNDO, REDO } from '../../stateManager/store/formCreation/types'
import { SAVE_SOLO } from '../../stateManager/store/solo/types'
import { BPMN_ACTION_TYPE } from '../../stateManager/store/common/types';

import { useSelector, useDispatch } from 'react-redux';
import { useLocation, matchPath, Link } from 'react-router-dom';
import { useHistory } from 'react-router'
import { useToast } from '../../helpers/commonFunction/useToast'

import { updateAppVersion, updateSelectedApp, updateAppBranch, updateSelectedBpmn, selectedDmn } from '../../stateManager/store/apps/actions';
import Form from "../apps/Assisted/forms/Form";
import Branch from "./Branch";
import { updateFormProperties } from '../../stateManager/store/formCreation/action';
import { setBPMNTarsVisibility } from '../../stateManager/store/common/action';
import { setGuideVisible, setStepIndex } from '../../stateManager/store/onboarding/action';
import ModalFooter from '../../helpers/commonUi/ModalFooter';
import { updateOnboarding } from '../../helpers/onboardingHelper';
import { AppState, RootState } from '../../stateManager/store';
import { NLUBasicNLPTabs } from './NLUBasicNLPTabs'
import { ReactComponent as Delete } from "../../../src/assets/svg/delete.svg"

const APP_DOWNLOAD_MODAL_TITLE = "Download App";
const APP_DOWNLOAD_MODAL_TEXT = "Are you sure you want to download App and all its components?";

interface BranchInterface {
  app_id: string;
  branch_id: string;
  branch_name: string;
  created_at: string;
  created_by: string;
  source: string;
  status: string;
  updated_at: string;
  updated_by: string;
}

const Header: React.FC = () => {
  const {info:onboardingInfo, guideVisible} = useSelector((state: any)=> state.onboarding)
  const userName = useSelector((state: any)=> state.user.data.user.userName)
  const { capabilities = null  } = useSelector((state: any) => state.user.userDetails)
  const selectedSoloInfo = useSelector((state: any) => state.solo.selectedSolo);
  const selectedDmnInfo = useSelector((state: any) => state.apps.selectedDmn);
  const selectedAiAgentName = useSelector((state: any) => state.apps.selectedAiAgentName);
  const selectedAssistedBpmn = useSelector((state: any) => state.apps.selectedBpmn);
  const selectedFormData = useSelector((state: any) => state.formcreation.selectedForm);
  const bpmnTarsVisibility = useSelector((state: any) => state.common.bpmnTarsVisibility);
  const [button, setButton] = useState({ preview: false, save: false, morePopver: false })
  const [duplicateState, setduplicateState] = useState({ visible: false })
  const [headerData, setheaderData] = useState<any>([])
  const [moreOptionState, setmoreOptionState] = useState({ visible: false })
  const [viewFormProperties, setViewFormProperties] = useState(false)
  const [importedAssets, setImportedAssets] = useState<any>([])
  const history: any = useHistory();
  const currentState: any = useSelector(state => {
    return state
  })
  const assetsList = useSelector((state: any) => state.assets.list)
  const selectedApp: any = currentState && currentState.apps && currentState.apps.selectedApp;

  const pathname = useLocation().pathname

  const getAppId: any = matchPath(pathname, {
    path: "/apps/list/:appId/",
    exact: false,
    strict: false
  })

  const appId = getAppId && getAppId.params && getAppId.params.appId

  const formIdPath: any = matchPath(pathname, {
    path: selectedApp.type === "a8solo" ? "/apps/list/:appId/solo/forms/list/:formId/create" : "/apps/list/:appId/assist/forms/list/:formId/create",
    exact: true,
    strict: false
  })

  const formId = formIdPath && formIdPath.params && formIdPath.params.formId
  const [appVersionId, setAppVersionId] = useState<string>('')

  const locationSplit = pathname.split('/');
  const location = locationSplit[1];
  const isAssistedJourney = pathname.endsWith("create") && locationSplit[4] === "journey" && locationSplit[5] === "assist"
  let tabLocation: any;

  const isChatRoute = locationSplit.length && (locationSplit[5] === "nlu" || locationSplit[5] === "events"|| locationSplit[5] === "qna" || locationSplit[5] === "content") 
  const isQNADialogRoute = locationSplit.length && ((locationSplit[5] === "events" && locationSplit[7] === "create") || (locationSplit[5] === "qna" && locationSplit[7] === "create") || (locationSplit[5] === "events" && locationSplit[8] === "edit") || (locationSplit[5] === "qna" && locationSplit[8] === "edit"))

  const dispatch = useDispatch();

  const currentOrganizationId = useSelector((state: any) => {
    return state.org.selectedOrg.id
  })

  const loggedInUserId = useSelector((state: any) => {
    return state.user.data.user.id
  })
  const originalFormData = useSelector((state: any) => {
    return state.formcreation.formData
  })

  const currentFormData = useSelector((state: any) => {
    return state.formcreation[formId] && JSON.stringify(state.formcreation[formId])
  })

  const tabData = currentFormData ? JSON.parse(currentFormData)[0] : null

  const currentAppversion = useSelector((state: any) => {
    return state.apps.appVersion && state.apps.appVersion[appId]
  })
  const currentAppBranch = useSelector((state: any) => {
    const selectedAppId = state.apps.selectedApp && state.apps.selectedApp.id
    return (state.apps.appBranch && state.apps.appBranch[selectedAppId]) || {}
  }, (left: any, right: any) => left.branchId === right.branchId)
  const { selectedOrg } = useSelector((state: AppState) => state.org)
  const { selectedApp: {chatType} } = useSelector((state: RootState) => state.apps)
  const { soloSaved, goBackSolo } = useSelector((state: any) => state.solo)
  const [versionList, setVersionList] = useState<any[]>([])
  const [dropDownVersionList, setDropDownVersionList] = useState<any[]>([])
  const [versionSearch, setVersionSearch] = useState<string>('')
  const [dropDownAppList, setDropDownAppList] = useState<any[]>([])
  const [appSearch, setAppSearch] = useState<string>('')
  const [branchList, setBranchList] = useState<any[]>([])
  const [dropDownBranchList, setDropDownBranchList] = useState<any[]>([])
  const [branchSearch, setBranchSearch] = useState<string>('')
  const [resourceLock, setResourceLock] = useState<any>({})
  const [lockVisible, setLockVisible] = useState(false)
  const [commitVisible, setCommitVisible] = useState(false)
  const { SuccessToast, ErrorToast, WarningToast } = useToast()
  const [appDropDownVisible, setAppDropDownVisible] = useState<boolean>(false)
  const [versionDropDownVisible, setVersionDropDownVisible] = useState<boolean>(false)
  const [branchDropDownVisible, setBranchDropDownVisible] = useState<boolean>(false)
  const [orgModalVisible, setOrgModalVisible] = useState<boolean>(false)
  const [editModalVisible, setEditModalVisible] = useState<boolean>(false)
  const [editFormData, setEditFormData] = useState<any>({})
  const [createBranchModalVisible, setCreateBranchModalVisible] = useState<boolean>(false)
  const [confirmationSoloPopup, setConfirmationSoloPopup] = useState(false)
  const [confirmationFormPopup, setConfirmationFormPopup] = useState(false)
  const [backClick, setBackClick] = useState(false);
  const [appDownloadModalVisibility, setAppDownloadModalVisibility] = useState<boolean>(false);
  let [formPropertiesData, setFormPropertiesData] = useState<any>({})
  const [branchHoveredIndex, setBranchHoveredIndex] = useState<number | undefined>();
  const [showBranchDeleteModal, setShowBranchDeleteModal] = useState<boolean>(false);
  const [branchDetails, setBranchDetails] = useState<BranchInterface | undefined>();

  useEffect(() => {
    if (currentState && currentState.apps && currentState.apps.appsList) {
      setDropDownAppList(currentState.apps.appsList)
    }
  }, [currentState])

  useEffect(() => {
    if (soloSaved && backClick) {
      // backFunctionality && history.goBack()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [soloSaved])

  useEffect(() => {
    if (locationSplit && locationSplit[6] === "solo") {
      setBackClick(false)
    }
  }, [locationSplit])


  const getBranches = useCallback(() => {
    if ((!orgPermissions?.includes("branch.View") || !orgPermissions.includes('app.View')) &&  loggedInUserId!=selectedOrg?.owner) {
      // ErrorToast("Error fetching branches")
      console.error("Error fetching branches")
      return
    } 
    Http.get(`branch/${appId}`).subscribe((res: any) => {
      setBranchList(res)
      setDropDownBranchList(res)
    }, (e) => {
      ErrorToast("Error fetching branches")
    })
  }, [appId])

  const getVersion = useCallback(
    () => {
      Http.get(`versions/${appId}?branchId=${currentAppBranch.branchId}`).subscribe((res: any) => {
        const versionCode: any = _.maxBy(res, 'version_code')
        if (!versionCode) {
          return;
        }
        const reindexs = _.findIndex(res, versionCode)
        res[reindexs]['currentVersion'] = true;
        const data = _.find(res, ['currentVersion', true])
        setAppVersionId(data.version_id)
        if (data) {
          DeploymentUpdateVerison.sendMessage({
            message: 'versionSwitched',
            data: {
              versionId: data.version_id,
              versionTag: data.version_tag,
              versionCode: data.version_code
            }
          })
          // Add previous version id into the store, used in data-ui (for checking previous version's schema)
          if (res.length > 1) {
            const previousVersion = _.find(res, ['version_code', versionCode.version_code - 1])
            dispatch(updateAppVersion({ key: appId, value: { appId: appId, versionId: data.version_id, previousVersionId: previousVersion.version_id, currentVersion: true } }))
          } else {
            dispatch(updateAppVersion({ key: appId, value: { appId: appId, versionId: data.version_id, previousVersionId: null, currentVersion: true } }))
          }
        }

        setVersionList(res)
        setDropDownVersionList(res)
      })
    },
    [dispatch, appId, currentAppBranch],
  )

  useEffect(() => {
    if (appId) {
      getBranches();
      getVersion();
    }
  }, [appId, getBranches, getVersion])

  useEffect(() => {
    const subscription = DeploymentUpdateVerison.getMessage().subscribe((data: any) => {
      if (data.message === 'versionCreated') {
        getVersion();
      }
    })
    return () => subscription.unsubscribe()
  }, [getVersion])

  let onEditForm: any = useRef(); // Used for form edit callback
  let onCreateBranch: any = useRef(); // Used for create branch callback

  useEffect(() => {
    const subscriber = ResourceLock.getMessage().subscribe((data) => {
      if (data.message === 'FORM_REFETCHED' || data.message === 'BPMN_REFETCHED' || data.message === 'SOLO_FORM_REFETCHED' || data.message === `DMN_REFETCHED` || data.resourceLock) {
        setResourceLock(data.resourceLock || {})
        data.refetchedCallback && data.refetchedCallback()
      }
    })
    return () => subscriber.unsubscribe()
  }, [])

  useEffect(() => {
    setResourceLock({})
  }, [pathname])

  const appPermissions = currentState.apps.selectedApp.permissions || []
  const orgPermissions = currentState.org.orgPermissions || []

  const currentStateAppList: any = currentState && currentState.apps && currentState.apps.appsList

  const activeStatus = {
    undo: false,
    redo: false
  }

  let actionStack: any;
  let actionPointer: number;

  if (currentState.formcreation.actionStack) {
    actionStack = currentState.formcreation.actionStack
    actionPointer = currentState.formcreation.actionPointer

    if (actionStack.length === 0) {
      activeStatus.undo = false
      activeStatus.redo = false
    } else if (actionPointer < actionStack.length && actionPointer > 0) {
      activeStatus.undo = true
      activeStatus.redo = true
    } else if (actionPointer === 0 && actionStack.length !== 0) {
      activeStatus.undo = false
      activeStatus.redo = true
    } else if (actionPointer === actionStack.length) {
      activeStatus.undo = true
      activeStatus.redo = false
    }
  }
  const isCheckedIn: boolean = resourceLock?.userId === loggedInUserId
  const isDraftForm = originalFormData !== currentFormData
  const isDmnCreation = (locationSplit[locationSplit.length - 1] === "create") && (locationSplit[5] === "dmn")
  const isFormCreation = (locationSplit[locationSplit.length - 1] === 'create') && (locationSplit[5] === 'forms')
  const isAssistCreation = (locationSplit[locationSplit.length - 1] === 'create') && (locationSplit[4] === 'journey') && (locationSplit[5] === 'assist')
  const isSoloCreation = (locationSplit[locationSplit.length - 1] === 'create') && (locationSplit[4] === 'journey') && (locationSplit[5] === 'solo')

  const onClickCheckout = () => {
    ResourceLock.sendMessage({
      message: isAssistCreation ? 'BPMN_REFETCH_LOCK' : isDmnCreation ? `DMN_REFETCH_LOCK` : isSoloCreation ? 'SOLO_BPMN_REFETCH_LOCK' : 'FORM_REFETCH_LOCK',
      callback: (data: any) => {
        if (data?.userId === loggedInUserId) {
          WarningToast('You have already checked out')
          ResourceLock.sendMessage({
            message: isAssistCreation ? 'BPMN_REFETCH' : isDmnCreation ? `DMN_REFETCH` : isSoloCreation ? 'SOLO_BPMN_REFETCH' : 'FORM_REFETCH',
          })
        } else {
          setLockVisible(true)
          if (guideVisible) {
            dispatch(setStepIndex(onboardingInfo.stepIndex + 1))
          }
        }
      }
    })
  }

  const onClickCommit = () => {
    ResourceLock.sendMessage({
      message: isAssistCreation ? 'BPMN_REFETCH_LOCK' : isDmnCreation ? `DMN_REFETCH_LOCK` : isSoloCreation ? 'SOLO_BPMN_REFETCH_LOCK' : 'FORM_REFETCH_LOCK',
      callback: (data: any) => {
        if (data?.userId === loggedInUserId) {
          setCommitVisible(true)
        } else if (!data.userId) {
          WarningToast('No one has checked out this resource. Commit Failed!')
          ResourceLock.sendMessage({
            message: isAssistCreation ? 'BPMN_REFETCH' : isDmnCreation ? `DMN_REFETCH` : isSoloCreation ? 'SOLO_BPMN_REFETCH' : 'FORM_REFETCH',
          })
        } else {
          WarningToast(`${data.userName} has already checked out this resource. Commit Failed!`)
          ResourceLock.sendMessage({
            message: isAssistCreation ? 'BPMN_REFETCH' : isDmnCreation ? `DMN_REFETCH` : isSoloCreation ? 'SOLO_BPMN_REFETCH' : 'FORM_REFETCH',
          })
        }
      }
    })
  }
  const onClickDownload=()=>{
    handleBpmnAction("DOWNLOAD")
  }

  const onClickSave = (resource: string) => {
    ResourceLock.sendMessage({
      message: isAssistCreation ? 'BPMN_REFETCH_LOCK' : isDmnCreation ? `DMN_REFETCH_LOCK` : isSoloCreation ? 'SOLO_BPMN_REFETCH_LOCK' : 'FORM_REFETCH_LOCK',
      callback: (data: any) => {
        if (data.userId === loggedInUserId) {
          if (resource === 'form') {
            formSave.sendMessage({ from: 'save' })
          } else if (resource === 'bpmn') {
            handleBpmnAction("SAVE")
            if (guideVisible) {
              const stepIndex = onboardingInfo.stepIndex;
              dispatch(setStepIndex(stepIndex + 1))
              updateOnboarding(userName, {...onboardingInfo, stepIndex: stepIndex + 1})
            }
            
          } else if (resource === "dmn") {
            handleBpmnAction("SAVE")
          }
        } else if (!data.userId) {
          WarningToast('No one has checked out this resource. Save Failed!')
          ResourceLock.sendMessage({
            message: isAssistCreation ? 'BPMN_REFETCH' : isDmnCreation ? `DMN_REFETCH` : isSoloCreation ? 'SOLO_BPMN_REFETCH' : 'FORM_REFETCH',
          })
        } else {
          WarningToast(`${data.userName} has already checked out this resource. Save Failed!`)
          ResourceLock.sendMessage({
            message: isAssistCreation ? 'BPMN_REFETCH' : isDmnCreation ? `DMN_REFETCH` : isSoloCreation ? 'SOLO_BPMN_REFETCH' : 'FORM_REFETCH',
          })
        }
      }
    })
  }

  const checkout = (resource: any) => {
    const { resourceId, type, resourceType } = resource
    const stepIndex = onboardingInfo.stepIndex;
    if (guideVisible) {
      dispatch(setStepIndex(stepIndex + 1))
    }
    Http.post((isAssistCreation || isFormCreation || isDmnCreation) ? `${resourceType}/${resourceId}/checkout` :
      `/apps/${appId}/solo-flows/${resourceId}/checkout `, {
      appId,
      versionId: appVersionId
    }).subscribe(() => {
      SuccessToast(`${type} checked out`)
      ResourceLock.sendMessage({ message: isAssistCreation ? 'BPMN_REFETCH' : isDmnCreation ? `DMN_REFETCH` : isSoloCreation ? 'SOLO_BPMN_REFETCH' : 'FORM_REFETCH' })
      setLockVisible(false)
      if (guideVisible) {
        const payload = {
          ...onboardingInfo,
          stepIndex: stepIndex + 1,
          [`${resourceType}Checkout`]: true
        }
        updateOnboarding(userName,payload)
      }
    }, (err) => {
      ErrorToast(`Error checking out ${type}: ${err.message || ''}`)
    })
  }
  const tabList = [
    "forms",
    "assist",
    "solo",
    "service",
    "functions",
    "ai-agents",
    "data",
    "dmn",
    "configuration",
    "acl",
    "deploy",
    "nlu",
    "content",
    chatType === 'genai' ? "events" : 'qna',
    "static-asset",
    "i18n",
    "dataModel",
    "security"
  ];
  const forceRelease = (resource: any) => {
    const data =
      isAssistCreation ? {
        appId,
        version: appVersionId
      } : {
        appId,
        versionId: appVersionId,
      }
    const { resourceId, type, resourceType } = resource
    Http.post((isAssistCreation || isFormCreation || isDmnCreation) ? `${resourceType}/${resourceId}/force-release` :
      `/apps/${appId}/solo-flows/${resourceId}/force-release`, data).subscribe((res) => {
        SuccessToast(`${type} force released successfully`)
        ResourceLock.sendMessage({ message: isAssistCreation ? 'BPMN_REFETCH' : isDmnCreation ? `DMN_REFETCH` : isSoloCreation ? 'SOLO_BPMN_REFETCH' : 'FORM_REFETCH' })
        setLockVisible(false)
      }, (err) => {
        ErrorToast(`Error force releasing ${type}: ${err.message || ''}`)
      })
  }

  let headerTitle: string = '';
  let TitleIcon: any
  let tabs: any[] = [];
  let backFunctionality: boolean = false;

  if (location === 'dashboard') {
    headerTitle = 'DASHBOARD'
    TitleIcon = DashboardIcon;
  }
  else if (location === 'profile') {
    headerTitle = 'PROFILE'
    TitleIcon = DashboardIcon;
  }
  else if (location === 'apps') {
    headerTitle = 'APPS'
    TitleIcon = AppsIcon;
    tabLocation = locationSplit[5]
    const selectedApp: any = currentState && currentState.apps && currentState.apps.selectedApp;

    if ((locationSplit[8] == undefined || (locationSplit[5] === "qna" && locationSplit[8] === "edit") || (locationSplit[5] === "events" && locationSplit[8] === "edit") || locationSplit[5] === "ai-agents") && tabList.includes(locationSplit[5])) {
      headerTitle = selectedApp?.displayName || selectedApp.name
    }
    let journeyRedirectpath = selectedApp.type === "a8flow" ? 'journey/assist/list' : "journey/solo/list"
    let serviceRedirectPath = selectedApp.type === 'a8flow' ? 'assist/service/list' : 'solo/service/list'
    let formRedirectPath = selectedApp.type === 'a8flow' ? 'assist/forms/list' : 'solo/forms/list'
    let functionRedirectPath = selectedApp.type === "a8flow" ? "assist/functions/list" : "solo/functions/list"
    let configurationRedirectPath = selectedApp.type === "a8flow" ? "assist/configuration/list" : "solo/configuration/list"
    let deployRedirectPath = selectedApp.type === "a8flow" ? "assist/deploy/list" : "solo/deploy/list"
    let dataRedirectPath = selectedApp.type === "a8flow" ? "assist/data/list" : "solo/data/list"
    let i18nRedirectPath = selectedApp.type === "a8flow" ? "assist/i18n" : "solo/i18n"
    let dataModelRedirectPath = selectedApp.type === "a8flow" ? "assist/dataModel/list" : "solo/dataModel/list"
    let secureVariableRedirectPath = selectedApp.type === "a8flow" ? "assist/security/secure-variables/list" : "solo/security/secure-variables/list"
    if (appId) {
      if (selectedApp.type === "a8solo") {
        tabs = [
          { _id: 'journey', name: selectedApp.type === "a8flow" ? 'Assisted' : "Solo", location: selectedApp.type === "a8flow" ? 'assist' : "solo", redirectTo: journeyRedirectpath },
          { _id: 'forms', name: 'Forms', location: 'forms', redirectTo: formRedirectPath },
          { _id: 'services', name: 'Services', location: 'service', redirectTo: serviceRedirectPath },
          { _id: 'functions', name: 'Functions', location: 'functions', redirectTo: functionRedirectPath },
          { _id: 'data', name: 'Data', location: 'data', redirectTo: dataRedirectPath },
          { _id: 'configuration', name: 'Configuration', location: 'configuration', redirectTo: configurationRedirectPath },
          { _id: 'ai-agents', name: 'AI Agent', location: 'aiAgents', redirectTo: configurationRedirectPath },
          { _id: 'secureVariables', name: 'Secure Variables', location: 'secure', redirectTo: secureVariableRedirectPath },
          { _id: 'deploy', name: 'Deploy', location: 'deploy', redirectTo: deployRedirectPath },
          { _id: 'i18n', name: 'Internationalization', location: 'internationalization', redirectTo: i18nRedirectPath },
          { _id: 'dataModel', name: 'Data Model', location: 'dataModel', redirectTo: dataModelRedirectPath }
        ]
      }
      else if (selectedApp.type === "a8flow") {
        tabs = [
          { _id: 'journey', name: selectedApp.type === "a8flow" ? 'Assisted' : "Solo", location: selectedApp.type === "a8flow" ? 'assist' : "solo", redirectTo: journeyRedirectpath },
          { _id: 'forms', name: 'Forms', location: 'forms', redirectTo: formRedirectPath },
          { _id: 'services', name: 'Services', location: 'service', redirectTo: serviceRedirectPath },
          { _id: 'functions', name: 'Functions', location: 'functions', redirectTo: functionRedirectPath },
          { _id: 'data', name: 'Data', location: 'data', redirectTo: dataRedirectPath },
          { _id: 'configuration', name: 'Configuration', location: 'configuration', redirectTo: configurationRedirectPath },
          { _id: 'secureVariables', name: 'Secure Variables', location: 'secure', redirectTo: secureVariableRedirectPath },
          { _id: 'acl', name: 'Variable Group', location: 'acl', redirectTo: "assist/security/acl/list" },
          { _id: 'deploy', name: 'Deploy', location: 'deploy', redirectTo: deployRedirectPath },
          { _id: 'i18n', name: 'Internationalization', location: 'internationalization', redirectTo: i18nRedirectPath },
          { _id: 'dataModel', name: 'Data Model', location: 'dataModel', redirectTo: dataModelRedirectPath }
        ]
      }
      if (selectedApp && selectedApp.type === "a8assist") {
        tabs = tabs.filter(x => x.name !== "BPMN" && x.name !== "Services" && x.name !== "Data");
      }
    }
    if (locationSplit[5] === "ai-agents" && locationSplit[7] === "create") {
      headerTitle = "Create Agent"
      TitleIcon = BackIcon;
      tabs = []
      backFunctionality = true
    }

    if (locationSplit[5] === "ai-agents" && locationSplit[8] === "edit") {
      headerTitle = selectedAiAgentName || "Edit Agent"
      TitleIcon = BackIcon;
      tabs = []
      backFunctionality = true
    }
    if (locationSplit[locationSplit.length - 1] === 'create') {
      if (isFormCreation) {
        headerTitle = 'FORMS';
      }
      if (isAssistCreation) {
        headerTitle = ('assisted').toLocaleUpperCase();
      } else if (isSoloCreation) {
        headerTitle = ("a8solo").toLocaleUpperCase();
      } else if (isDmnCreation) {
        headerTitle = "DMN"
      }
      TitleIcon = BackIcon;
      tabs = []
      backFunctionality = true
    }
  }
  else if ((location === 'organization') && (locationSplit[3] === 'env')) {
    headerTitle = 'ENVIRONMENT'
    TitleIcon = EnvironmentIcon;
  }
  else if ((location === 'organization') && (locationSplit[3] === 'themeManager')) {
    headerTitle = 'THEME MANAGER'
    TitleIcon = ThemeHeader
  }
  else if (location === 'organization') {
    tabLocation = locationSplit[3]

    if (tabLocation) {
      headerTitle = 'ADMIN'
      TitleIcon = AdminIcon;
      tabs = [
        { _id: 'teams', name: 'Teams', location: 'teams', redirectTo: 'teams' },
        { _id: 'users', name: 'Users', location: 'users', redirectTo: 'users' },
        { _id: 'policy', name: 'Policy', location: 'policy', redirectTo: 'policy' },
        { _id: 'audit', name: 'Audits', location: 'audit', redirectTo: 'audit' }
      ]
    } else {
      headerTitle = 'ORGANIZATION'
      TitleIcon = OrgIcon;
    }

  }
  else if (location === 'themeManager') {
    headerTitle = 'THEME MANAGER'
    TitleIcon = ThemeManagerIcon;
  } else if (location === 'marketplace') {
    tabLocation = locationSplit[2]
    headerTitle = 'MARKETPLACE';
    TitleIcon = MarketplaceIcon;
    tabs = [
      { _id: "dashboard", name: 'Dashboard', location: 'dashboard', redirectTo: 'dashboard' },
      { _id: "widget", name: 'Widgets', location: 'widgets', redirectTo: 'widgets' },
      { _id: "apps", name: 'Apps', location: 'apps', redirectTo: 'apps' },
      { _id: "function", name: 'Functions', location: 'functions', redirectTo: 'functions' },
    ]
  }

  const handleSaveSolo = () => {
    dispatch({
      type: SAVE_SOLO,
      data: true
    });
  }

  const handleUndo = () => {
    if (actionStack && activeStatus.undo) {
      actionStack[actionPointer - 1].undo();
      dispatch({
        type: UNDO,
      })
    }
  }

  const handleRedo = () => {
    if (actionStack && activeStatus.redo) {
      actionStack[actionPointer].redo();
      dispatch({
        type: REDO,
      })
    }
  }

  const handleBpmnAction = (data: string) => {
    dispatch({
      type: BPMN_ACTION_TYPE,
      data
    })
  }

  // const versionId = currentAppversion && currentAppversion.versionI
  const currentAppversionData = _.find(versionList, ['version_id', (currentAppversion) ? currentAppversion.versionId : ""])

  const isCurrentVersion = currentAppversionData && currentAppversionData.currentVersion
  const isAssistAuthorized = (orgPermissions.includes('bpmn.Edit') || appPermissions.includes('bpmn.Edit'))
  const isFormAuthorized = (orgPermissions.includes('forms.Edit') || appPermissions.includes('forms.Edit'))
  const isDMNAuthorized = (orgPermissions.includes('dmn.Edit') || appPermissions.includes('dmn.Edit'))
  const canDMNForceRelease = (orgPermissions.includes('dmn.ForceReleaseLock') || appPermissions.includes('dmn.ForceReleaseLock'))
  const canForceReleaseJourney = (orgPermissions.includes('bpmn.ForceReleaseLock') || appPermissions.includes('bpmn.ForceReleaseLock'))
  const canForceReleaseForm = (orgPermissions.includes('forms.ForceReleaseLock') || appPermissions.includes('forms.ForceReleaseLock'))
  const canDeleteBranches = orgPermissions.includes('branch.Delete');
  
  const branchChange = ({ key }: any) => {
    if (key) {
      setBranchDropDownVisible(false)
      setBranchSearch('')
      // Delaying intentionally to avoid dropdown expansion on state change
      setTimeout(() => {
        setDropDownBranchList(branchList)
      }, 300)
      const data = dropDownBranchList[key]
      if (data) {
        dispatch(updateAppBranch({
          key: appId,
          value: {
            branchName: data.branch_name,
            branchId: data.branch_id
          }
        }))
      }
    }
  }

  const versionChange = ({ key }: any) => {
    if (key) {
      setVersionDropDownVisible(false)
      setVersionSearch('')
      // Delaying intentionally to avoid dropdown expansion on state change
      setTimeout(() => {
        setDropDownVersionList(versionList)
      }, 300)
    }
    const data = dropDownVersionList[key]
    if (data) {
      DeploymentUpdateVerison.sendMessage({
        message: 'versionSwitched',
        data: {
          versionId: data.version_id,
          versionTag: data.version_tag,
          versionCode: data.version_code
        }
      })
      dispatch(updateAppVersion({ key: appId, value: { appId: appId, versionId: data['version_id'], currentVersion: (data.currentVersion) ? true : false } }))
    }
  }

  const appChange = (data: any) => {
    const index: number = data.key
    if (index) {
      setAppDropDownVisible(false)
      setAppSearch('')
      // Delaying intentionally to avoid dropdown expansion on state change
      setTimeout(() => {
        currentStateAppList && setDropDownAppList(currentStateAppList)
      }, 300)
    }
    const selectedApp: any = dropDownAppList[index]
    if (selectedApp) {
      dispatch(updateSelectedApp({
        id: selectedApp.appId,
        name: selectedApp.name,
        type: selectedApp.type,
        permissions: selectedApp.permissions,
        displayName: selectedApp?.displayName
      }))
      dispatch(updateAppBranch({
        key: selectedApp.appId,
        value: {
          branchName: selectedApp.branches[0] && selectedApp.branches[0]["f2"],
          branchId: selectedApp.branches[0] && selectedApp.branches[0]["f1"]
        }
      }))
      // history.push("/apps/list/" + selectedApp.appId + "/Assisted/assist")
      history.push("/apps/list/" + selectedApp.appId + "/journey/solo")
      DeploymentUpdateVerison.sendMessage({
        message: 'appSwitched',
        data: {}
      })
    }
  }

    const onDownloadAppConfirmation = () => {
      Http.get(
        `org/${currentOrganizationId}/apps/${appId}/export?version=${currentAppversion.versionId}&branch=${currentAppBranch.branchId}`,
        {
          responseType: "blob",
        }
      ).subscribe(
        (appRes: any) => {
          const appName =
            currentState &&
            currentState.apps &&
            currentState.apps.selectedApp &&
            currentState.apps.selectedApp.name;
          // const versionName = currentAppversion;
          const link = document.createElement("a");
          const url = URL.createObjectURL(appRes);
          link.href = url;
          link.download = `${appName}.zip`;
          link.click();
          setAppDownloadModalVisibility(false);
        },
        (err) => {
          console.log(err);
          ErrorToast("Invalid BPMN journey");
        }
      );
    };

  const handleDeleteBranch = (branch: BranchInterface | undefined) => {
    setShowBranchDeleteModal(false);
    if (!orgPermissions.includes('branch.Delete') || !orgPermissions.includes('app.View') && loggedInUserId != selectedOrg?.owner) {
      ErrorToast("Not Authorized: Error deleting branch");
      return;
    }

    Http.post(`branch/${branch?.app_id}/${branch?.branch_id}`).subscribe((res: any) => {
      if (branch?.branch_id === currentAppBranch.branchId) {
        dispatch(updateAppBranch({
          key: appId,
          value: {
            branchName: branchList[0].branch_name,
            branchId: branchList[0].branch_id
          }
        }))
      }
      setBranchList(branchList.filter(branch => branch.branch_id !== res[0].branch_id));
      setDropDownBranchList(dropDownBranchList.filter(branch => branch.branch_id !== res[0].branch_id));
      SuccessToast(`Branch deleted successfully`);
    }, (err) => {
      console.log(err);
      if (err === "Forbidden") {
        ErrorToast("Not Authorized: Error deleting branch");
      }
    })
  }

  const branchDropDown = (
    <Menu data-test-id="branch_change" onClick={branchChange} className={style.versionMenu} style={{ maxHeight: '300px', overflow: 'auto' }}>
      <div className={style.branchCreateButtonContainer} onClick={() => {
        setCreateBranchModalVisible(true)
        setBranchDropDownVisible(false)
      }}>
        <div data-test-id="create_branch" className={style.branchCreateButton}>CREATE BRANCH</div>
      </div>
      <Input
        data-test-id="search"
        style={{ margin: '1px 4px', width: 'calc(100% - 8px)' }}
        placeholder="Search...."
        value={branchSearch}
        onChange={(e) => {
          const val = e.target.value.toLowerCase()
          setBranchSearch(val)
          if (val === '') {
            setDropDownBranchList(branchList)
          } else {
            const filteredList = branchList.filter((branch: any) => branch.branch_name.toLowerCase().includes(val))
            setDropDownBranchList(filteredList)
          }
        }}
      />
      {
        dropDownBranchList && dropDownBranchList.length > 0 && dropDownBranchList.map((branch, key) => {
          const isActive = currentAppBranch && (currentAppBranch.branchId === branch.branch_id)
          return (
            <Menu.Item onMouseEnter={() => setBranchHoveredIndex(key)} onMouseLeave={() => setBranchHoveredIndex(undefined)} data-test-id={`branch_name${branch.branch_name}`} key={key} style={{ color: isActive ? '#1890ff' : '', display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              {branch.branch_name}
              {branch.branch_name !== "main" && canDeleteBranches && branchHoveredIndex === key &&
                <Delete width={14} height={15}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowBranchDeleteModal(true);
                    setBranchDetails(branch);
                    setBranchDropDownVisible(false);
                  }}
                />
              }
            </Menu.Item>
          )
        })
      }
    </Menu>
  );

  const menu = (
    <Menu data-test-id="version_change" onClick={versionChange} className={style.versionMenu} style={{ maxHeight: '300px', overflow: 'auto' }}>
      <Input
        data-test-id="search"
        style={{ margin: '1px 4px', width: 'calc(100% - 8px)' }}
        placeholder="Search...."
        value={versionSearch}
        onChange={(e) => {
          const val = e.target.value.toLowerCase()
          setVersionSearch(val)
          if (val === '') {
            setDropDownVersionList(versionList)
          } else {
            const filteredList = versionList.filter((version: any) => `${version.version_tag}(${version.version_code})`.toLowerCase().includes(val))
            setDropDownVersionList(filteredList)
          }
        }}
      />
      {
        currentAppversionData && dropDownVersionList && dropDownVersionList.map((version, key) => {
          const isActive: boolean = (`${currentAppversionData.version_tag}(${currentAppversionData.version_code})` === `${version.version_tag}(${version.version_code})`)
          return (
            // <Menu.Item key={key} className={ classNames({ [style.versionHighlight]: (currentAppversion) ? currentAppversion.versionId === version.version_id : false})}>
            <Menu.Item data-test-id={`${version.version_tag}(${version.version_code})`} key={key} style={{ color: isActive ? '#1890ff' : '' }}>
              {version.version_tag}({version.version_code})
            </Menu.Item>
          )
        })
      }
    </Menu>
  );

  const appsDropdown = (
    <Menu data-test-id="menu" onClick={appChange} className={style.versionMenu} style={{ maxHeight: '300px', overflow: 'auto' }}>
      <Input
        data-test-id="search"
        style={{ margin: '1px 4px', width: 'calc(100% - 8px)' }}
        placeholder="Search...."
        value={appSearch}
        onChange={(e) => {
          const val = e.target.value.toLowerCase()
          setAppSearch(val)
          const appList = currentStateAppList
          if (val === '') {
            setDropDownAppList(appList)
          } else {
            const filteredList = appList && appList.filter((app: any) => app.name.toLowerCase().includes(val))
            setDropDownAppList(filteredList)
          }
        }}
      />
      {
        currentState && currentState.apps && currentState.apps.selectedApp && dropDownAppList && dropDownAppList.map((app: any, index: number) => {
          const isActive: boolean = (`${currentState.apps.selectedApp.name}` === `${app.name}`)
          return (
            <Menu.Item data-test-id={`${app.name}`} key={index} style={{ color: isActive ? '#1890ff' : '' }}>
              {app.name}
            </Menu.Item>
          )
        })
      }
    </Menu>
  );

  let handleDuplicateSetState = () => {
    setduplicateState({ visible: true })
    setmoreOptionState({ visible: false })
  }


  const handleBackClick = () => {
    setConfirmationSoloPopup(true);
    setBackClick(true);
  }

  const handleFormBackClick = () => {
    setConfirmationFormPopup(true);
  }

  HeaderData.getMessage().subscribe((res: any) => {
    setheaderData(res)
  })

  formPreview.getMessage().subscribe((res: formPreviewType) => {
    if (res && res.hide) {
      setButton(res.hide);
    }
  })



  const handleEditFormIconClick = () => {
    Http.get(`apps/${appId}/forms/${formId}?versionId=${appVersionId}`).subscribe((res: any) => {
      setEditFormData(res[0])
      setEditModalVisible(true)
      setmoreOptionState({ visible: false })
    })
  }

  const reloadTheme = () => {
    ThemeReload.sendMessage()
  }


  const setFormProperties = (() => {
    dispatch(updateFormProperties({
      formid: formId,
      id: tabData.id,
      data: {
        formProperties: {
          ...tabData.formProperties,
          importedAssets: [...importedAssets]
        }
      },
    }))
  })


  const morePopovercontent = (
    <div className={style.moreOptionContent_Main}  >
      <div className={style.moreOptionContent_Inner} onClick={() => {
        setViewFormProperties(true)
        setmoreOptionState({ visible: false })
      }}>
        <img data-test-id="form_properties" src={settingIcons} className={style.moreOptionContent_Img} alt="morIcon" />
        <div>Form Properties</div>
      </div>
      <div className={style.moreOptionContent_Inner} onClick={handleDuplicateSetState}>
        <img data-test-id="duplicate" src={duplicate} alt="morIcon" className={style.moreOptionContent_Img} />
        <div>Duplicate</div>
      </div>
      <div className={style.moreOptionContent_Inner} onClick={handleEditFormIconClick}>
        <img data-test-id="edit" src={editIcon} alt="morIcon" className={style.moreOptionContent_Img} />
        <div>Edit</div>
      </div>
      <div className={style.moreOptionContent_Inner} style={{ paddingBottom: "0px" }}>
        <img data-test-id="delete" src={deleteIcon} alt="morIcon" className={style.moreOptionContent_Img} />
        <div>Delete</div>
      </div>
    </div>
  );
  const currentVersion = headerData && headerData.length > 0 && headerData[0].currentVersion;
  const onRedirect = (path: string) => {
    location === "apps" && history.push("/apps/list/" + appId + "/" + path);
    location === "organization" &&
      tabLocation &&
      history.push("/organization/" + currentOrganizationId + "/" + path);
    location === "marketplace" &&
      tabLocation &&
      history.push("/marketplace/" + path);
  };

  const commitChanges = () => {
    if (isAssistCreation || isSoloCreation || isDmnCreation) {
      handleBpmnAction("COMMIT")
    } else {
      formSave.sendMessage({ from: 'commit' })
    }
    setCommitVisible(false)
  }

  const discardChanges = () => {
    if (isAssistCreation || isSoloCreation || isDmnCreation) {
      handleBpmnAction("DISCARD")
    } else {
      formSave.sendMessage({ from: 'commit', discard: true })
    }
    setCommitVisible(false)
  }

  if (location === "home") {
    return <></>
  }
  return (location !== 'profile') ?
    (
      <div className={style.header}>
        <div className={style.tabs} style={{ width: tabList.includes(locationSplit[5]) && locationSplit[8] != "create" ? "250px" : "", height: tabList.includes(locationSplit[5]) && locationSplit[8] != "create" ? "100%" : "" }}>
          <div data-test-id="title" className={style.title} style={{ flexShrink: 0, paddingLeft: "14px", textAlign: tabList.includes(locationSplit[5]) && locationSplit[8] != "create" ? "start" : "center" }}
          // backFunctionality && history.push(locationSplit.slice(0,-2).join('/'))
          >
            {TitleIcon && (!(tabList.includes(locationSplit[5]) && (locationSplit[8] == undefined || (locationSplit[5] === "qna" && locationSplit[8] === "edit") || (locationSplit[5] === "events" && locationSplit[8] === "edit"))) || 
              (locationSplit[5] === "ai-agents" && locationSplit[8] === "edit") ||
              (locationSplit[5] === "ai-agents" && locationSplit[7] === "create")  
          ) && <TitleIcon onClick={() => {
              if (!goBackSolo && soloSaved && locationSplit[5] === "solo") {
                WarningToast("Please close the properties panel and save your changes then go back")
              }
              locationSplit[5] === "solo"? (!soloSaved && isCheckedIn) ? handleBackClick()
                  : backFunctionality && history.goBack()
                : locationSplit[5] === "forms"
                  ? isDraftForm
                    ? handleFormBackClick()
                    : !isDraftForm && backFunctionality && history.goBack()
                  : backFunctionality && history.goBack();
              dispatch(updateSelectedBpmn(""))
              dispatch(selectedDmn(""))
            }} style={{ cursor: backFunctionality ? 'pointer' : undefined, color: '#15808C' }} height='20px' width='20px' />}


            {isChatRoute &&
              <Link to={isQNADialogRoute ? `/apps/list/${appId}/solo/${chatType === 'genai' ? 'events': 'qna'}` : `/apps/list/${appId}/journey/solo/list`}>
                <img style={{ cursor: "pointer", marginRight: 10 }} alt="go back" src={SoloChatBackIcon} />
              </Link>
            }

            {locationSplit && locationSplit[5] === "solo" && locationSplit[locationSplit.length - 1] === "create" &&
              <img style={{ marginLeft: "-8px", marginRight: "8px" }} alt="soloIcon" src={soloIcon} />}
            <div style={{ display: "flex", gap: 10 }}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span
                  style={{
                    fontWeight: tabList.includes(locationSplit[5]) &&
                      locationSplit[8] == undefined ? 600 : 400,
                    color: tabList.includes(locationSplit[5]) && (locationSplit[8] == undefined || (locationSplit[5] === "qna" && locationSplit[8] === "edit") || (locationSplit[5] === "events" && locationSplit[8] === "edit")) ? "#F1722E" : "",
                    maxWidth: tabList.includes(locationSplit[5]) && locationSplit[8] != "create" && locationSplit[6] === "basic-nlp"
                      ? "250px"
                      : "",
                    minWidth: '50px',
                    display: "flex",
                    gap: "10px"
                  }}
                  title={tabList.includes(locationSplit[5]) && locationSplit[8] != "create" ? headerTitle : ""}
                >
                  <div 
                    style={{
                      whiteSpace: tabList.includes(locationSplit[5]) && locationSplit[8] != "create" ? "nowrap" : "normal",
                      overflow: tabList.includes(locationSplit[5]) && locationSplit[8] != "create" ? "hidden" : "",
                      textOverflow: tabList.includes(locationSplit[5]) && locationSplit[8] != "create" ? "ellipsis" : "",
                      fontWeight: 600,
                      color: "#292D32"
                    }}
                  >
                    {headerTitle}
                  </div>
                  {appId && <AppType type={selectedApp.type} />}
                </span>       
                {locationSplit && locationSplit[5] === "nlu" && (
                  <div style={{
                    color: '#6E747C',
                    fontSize: 12,
                  }}>
                    <span style={{ cursor: "pointer" }} role="button" onClick={() => {
                      history.push(`/apps/list/${appId}/journey/solo/list`)
                    }}>NLU</span>
                    <span>{` > `}</span>
                    <span>{locationSplit[6] === "basic-nlp" ? 'Basic NLP' : 'Tokens'}</span>
                  </div>
                )}
                {locationSplit && locationSplit[5] === (chatType === 'genai' ? "events" : 'qna') && (
                  <div style={{
                    color: '#6E747C',
                    fontSize: 12,
                  }}>
                    <span style={{
                      color: '#121212',
                      fontSize: 14,
                      fontWeight: 600,
                    }}>{locationSplit[7] === "create" ? `Create ${selectedApp.chatType === 'genai' ? 'Event' : 'Dialog'}` : locationSplit[8] === "edit" ? `Edit ${selectedApp.chatType === 'genai' ? 'Event' : 'Dialog'}` : `${selectedApp.chatType === 'genai' ? 'Event' : 'QnA'}`}</span>
                  </div>
                )}
              </div>
              {locationSplit && locationSplit[6] === "basic-nlp" && <NLUBasicNLPTabs />}
            </div>
            {locationSplit[5] === 'assist' && locationSplit[locationSplit.length - 1] === "create" && selectedAssistedBpmn &&
              <span style={{ borderLeft: '1px solid #CAD5E9', marginLeft: 10 }}>
                <span style={{ margin: '0px 10px', textTransform: 'capitalize', fontSize: 14, fontWeight: 600, color: '#000D1A' }}>{selectedAssistedBpmn.bpmnName}</span>

              </span>
            }

            {locationSplit[5] === 'dmn' && locationSplit[locationSplit.length - 1] === "create" && selectedDmnInfo &&
              <span style={{ borderLeft: '1px solid #CAD5E9', marginLeft: 10 }}>
                <span style={{ margin: '0px 10px', textTransform: 'capitalize', fontSize: 14, fontWeight: 600, color: '#000D1A' }}>{selectedDmnInfo.dmnName}</span>

              </span>
            }


            {locationSplit[locationSplit.length - 1] === "create" && locationSplit[5] === "forms" && selectedFormData &&
              <span style={{ borderLeft: '1px solid #CAD5E9', marginLeft: 10 }}>
                <span style={{ margin: '0px 10px', textTransform: 'capitalize', fontSize: 14, fontWeight: 600, color: '#000D1A' }}>{selectedFormData.displayName}</span>
              </span>
            }

            {locationSplit[5] === 'solo' && locationSplit[locationSplit.length - 1] === "create" && selectedSoloInfo && selectedSoloInfo.name && <span style={{ borderLeft: '1px solid #CAD5E9', marginLeft: 10 }}><span style={{ margin: '0px 10px', textTransform: 'capitalize', fontSize: 14, fontWeight: 600, color: '#000D1A' }}>{selectedSoloInfo.name}</span><span><img alt="icons" style={{ marginBottom: "2px" }} src={selectedSoloInfo.type === 'public' ? publicIcon : privateIcon} /></span></span>}
            {isFormCreation && isDraftForm && <span style={{ marginLeft: '8px', color: '#f1722e' }}> - DRAFT</span>}
            {isAssistCreation && (!isAssistAuthorized || !isCheckedIn || !isCurrentVersion || !isDMNAuthorized) && <span style={{ marginLeft: '8px', color: '#f1722e' }}> - READ ONLY</span>}
            {(isAssistCreation && isAssistAuthorized && isCheckedIn && isCurrentVersion) && <div style={{ display: "flex" }} id="js-download-diagram">
              <div data-test-id="bpmn_undo" className="icons" onClick={() => handleBpmnAction("UNDO")}>
                <Tooltip placement="bottomLeft" title={"undo"}   >
                  <img src={undo} alt="simple"
                  />
                </Tooltip>
              </div>
              <div data-test-id="bpmn_redo" style={{ marginLeft: "18px" }} className="icons" onClick={() => handleBpmnAction("REDO")}>
                <Tooltip placement="bottomLeft" title={"redo"}>
                  <img src={unselected_redo} alt="simple"
                  />
                </Tooltip>
              </div>
            </div>
            }
            {!tabList.includes(locationSplit[5]) && <>{
              tabs.map((tab) => {
                const active = (tab.location === tabLocation) || (tab.location==="audit" && tabLocation=="downloads")  ? style.active : ''
                return (
                  <div data-test-id={tab._id + "_tab"} key={tab._id} onClick={() => onRedirect(tab.redirectTo)} className={style.tab + ' ' + active}>
                    {tab.name}
                  </div>

                )
              })
            }
            </>}
          </div>
        </div>
        {
          (isFormCreation && isFormAuthorized && isCheckedIn && isCurrentVersion) &&
          <div className={style.undoRedo}>
            <Undo data-test-id="undo" height='25px' width='25px' fill={activeStatus.undo ? '#1D7AFF' : '#d3d3d3'} onClick={handleUndo} />
            <Redo data-test-id="redo" height='25px' width='25px' fill={activeStatus.redo ? '#1D7AFF' : '#d3d3d3'} onClick={handleRedo} />
          </div>
        }

        <div className={style.action}>
          {
            (isAssistCreation || isFormCreation || isSoloCreation || isDmnCreation) ?
              (
                isCurrentVersion &&
                (<>
                  {isFormCreation && isCurrentVersion && isFormAuthorized && isCheckedIn &&
                    <div style={{ cursor: "pointer", marginRight: "24px" }}>
                      <ImportWidget formId={formId} appId={appId} />
                    </div>
                  }
                  {isFormCreation && !button.morePopver && currentVersion && isFormAuthorized && isCheckedIn && <Popover placement="bottom" content={morePopovercontent}
                    visible={moreOptionState.visible}
                    trigger="click"
                    onVisibleChange={(e) => {
                      setmoreOptionState({ visible: e })
                    }}
                  >
                    <div data-test-id="more" style={{ cursor: "pointer", marginRight: '24px' }} onClick={() => {
                      setmoreOptionState({ visible: true })
                    }}>
                      <MoreIcon height='28px' width='28px' />
                    </div>
                  </Popover>}
                  {(((isFormCreation && isFormAuthorized) || (isAssistCreation && isAssistAuthorized) || (isDMNAuthorized && isDmnCreation)) && !isCheckedIn && isCurrentVersion) && (
                    <div className={style.button}>
                      <Button className={"tour_journey_checkout"} dataTestId="bpmn_checkout" color="primary" size="extra-small" onClick={onClickCheckout}>
                        CHECKOUT
                      </Button>
                    </div>
                  )}
                  {isFormCreation && isFormAuthorized && isCurrentVersion && isCheckedIn &&
                    <>             
                      <div className={style.button}>
                        <Button dataTestId="form_commit" color="primary" size="extra-small" onClick={onClickCommit}>
                          COMMIT
                        </Button>
                      </div>
                      <div className={style.button}>
                        <Button dataTestId="save" color="primary" size="extra-small" onClick={() => onClickSave('form')}>
                          SAVE
                        </Button>
                      </div>
                    </>
                  }
                  {isFormCreation && <div className={style.button}>
                    <Button dataTestId="preview" color="primary" size="extra-small" onClick={() => formPreview.sendMessage({ from: 'preview' })}>
                      PREVIEW
                    </Button>
                  </div>}
                  {(isAssistCreation && isAssistAuthorized && isCurrentVersion && isCheckedIn) && (
                    <>
                      {isAssistedJourney && (
                        <div style={{ margin: "0 16px" }}>
                          <img
                            src={TarsIcon}
                            alt="tars"
                            width="33"
                            height="33"
                            onClick={() => {
                              dispatch(setBPMNTarsVisibility(!bpmnTarsVisibility));
                            }}
                          />
                        </div>
                      )}
                      <div className={style.button}>
                        <AntButton  style={{color:"#052f35 ",border:"1px solid #052f35 ",fontSize:12}} color="primary" onClick={onClickDownload}>
                          DOWNLOAD
                        </AntButton>
                      </div>
                      <div className={style.button}>
                        <Button dataTestId="bpmn_commit" color="primary" size="extra-small" onClick={() => onClickCommit()}>
                          COMMIT
                        </Button>
                      </div>
                      <div className={style.button}>
                        <Button className={"bpmn_save"} dataTestId="bpmn_save" color="primary" size="extra-small" onClick={() => onClickSave('bpmn')}>
                          SAVE
                        </Button>
                      </div>
                    </>
                  )}
                  {
                    (isDmnCreation && isCheckedIn && isDMNAuthorized && isCurrentVersion) && (
                      <>
                        <div className={style.button}>
                          <Button dataTestId="bpmn_commit" color="primary" size="extra-small" onClick={() => { onClickCommit() }}>
                            COMMIT
                          </Button>
                        </div>
                        <div className={style.button}>
                          <Button dataTestId="bpmn_save" color="primary" size="extra-small" onClick={() => onClickSave('dmn')}>
                            SAVE
                          </Button>
                        </div>
                      </>
                    )
                  }
                  {
                    (!isCheckedIn && locationSplit[5] === 'solo') && (
                      <>
                        <div className={style.button}>
                          <Button
                            // disabled={soloSaved}
                            dataTestId="solo_save"
                            color="secondary"
                            size="extra-small"
                            onClick={onClickCheckout}
                            className={"tour_journey_checkout"}
                          >
                            CHECKOUT
                          </Button>
                        </div>
                      </>
                    )}
                  {
                    (isCheckedIn && locationSplit[5] === 'solo') && (
                      <>
                        <div className={style.button}>
                          <Button
                            // disabled={soloSaved}
                            dataTestId="solo_save"
                            color="secondary"
                            size="extra-small"
                            onClick={() => onClickCommit()}
                          >
                            COMMIT
                          </Button>
                        </div>
                        <div className={style.button}>
                          <Button
                            // disabled={soloSaved}
                            dataTestId="solo_save"
                            color="secondary"
                            size="extra-small"
                            onClick={handleSaveSolo}
                          >
                            SAVE
                          </Button>
                        </div>
                      </>
                    )
                  }
                </>))
              :
              <>
                {appId && !isQNADialogRoute && !capabilities &&
                  <>
                    <div className={style.download_app} onClick={() => setAppDownloadModalVisibility(true)}>
                      <Import title="Download App" data-test-id="show_modal" height="14px" width="14px" />
                    </div>
                    <div style={{height: "25px", width: "2px", borderLeft: "1px solid #95ABD34D", marginLeft: 10}}></div>
                    <Dropdown
                      data-test-id="branch_dropdown"
                      overlay={branchDropDown}
                      trigger={['click']}
                      disabled={!(currentAppBranch && currentAppBranch.branchId)}
                      onVisibleChange={(visible) => {
                        if (!visible) {
                          setBranchSearch('')
                          setTimeout(() => setDropDownBranchList(branchList), 300)
                        }
                        setBranchDropDownVisible(visible)
                      }}
                      visible={branchDropDownVisible}
                    >
                      <div data-test-id="current_app_branch" style={{cursor: (currentAppBranch && currentAppBranch.branchId) ? 'pointer' : 'not-allowed' }} className={style.dropdownItem}>
                        <BranchIcon />
                        <span >{(currentAppBranch && currentAppBranch.branchId) ? currentAppBranch.branchName : 'legacy'}</span>
                        <CaretDown style={{ color: '#15808C' }} />
                      </div>
                    </Dropdown>
                    {!isChatRoute && !capabilities && (
                      <Dropdown
                        data-test-id="version_list"
                        overlay={menu}
                        trigger={['click']}
                        onVisibleChange={(visible) => {
                          if (!visible) {
                            setVersionSearch('')
                            setTimeout(() => setDropDownVersionList(versionList), 300)
                          }
                          setVersionDropDownVisible(visible)
                        }}
                        visible={versionDropDownVisible}
                      >
                        <div className={style.dropdownItem}>
                          {currentAppversionData && <span data-test-id="version_tag" >{`${currentAppversionData.version_tag}(${currentAppversionData.version_code})`}</span>}
                          <CaretDown style={{ color: '#15808C' }} />
                        </div>
                      </Dropdown>
                    )}
                  </>
                }
                {!isQNADialogRoute && !capabilities && (
                  <div data-test-id="org" className={`${style.dropdownItem} ${capabilities && style.disableOrgModal}`} onClick={() => !capabilities &&  setOrgModalVisible(true)}>  
                    <OrgIcon style={{ marginLeft: "0px" }} />
                    <span data-test-id="selected_org">{currentState && currentState.org && currentState.org.selectedOrg && currentState.org.selectedOrg.orgName}</span>
                    <CaretDown style={{ color: '#15808C' }} />
                  </div>
                )}
              </>
          }
          <DuplicateFormModal
            data-test-id="duplicate_form_modal"
            visible={duplicateState.visible}
            setvisible={(e: any) => {
              setduplicateState({ visible: e })
            }}
            appType="assisted"
          />
          <Modal
            id="editForm"
            dataTestId="edit_form"
            title={"EDIT FORM"}
            visible={editModalVisible}
            onCancel={() => {
              setEditModalVisible(false);
            }}
            unmountOnCancel={true}
            footer={{
              enable: true,
              okText: "SAVE",
              cancelText: "CANCEL",
              onOk: () => {
                onEditForm && onEditForm.current && onEditForm.current();
                setEditModalVisible(false);
              }
            }}
          >
            <Form
              data-test-id="form"
              appId={appId}
              getForms={reloadTheme}
              editInitialData={editFormData}
              onSubmit={(submit: any) => (onEditForm.current = submit)}
              editable={true}
              versionId={appVersionId}
            ></Form>
          </Modal>
          <OrgList setOrgModalVisible={setOrgModalVisible} orgModalVisible={orgModalVisible} />
          <Modal
            id="createBranch"
            dataTestId="create_branch"
            title={"CREATE BRANCH"}
            visible={createBranchModalVisible}
            onCancel={() => {
              setCreateBranchModalVisible(false);
            }}
            unmountOnCancel={true}
            footer={{
              enable: true,
              okText: "CREATE",
              cancelText: "CANCEL",
              onOk: () => {
                const shouldModalClose = onCreateBranch && onCreateBranch.current && onCreateBranch.current();
                setCreateBranchModalVisible(!shouldModalClose);
              }
            }}
          >
            <Branch
              data-test-id="branch"
              appId={appId}
              getBranches={getBranches}
              branchList={branchList}
              onSubmit={(submit: any) => (onCreateBranch.current = submit)}
              versionData={currentAppversionData}
              branchData={currentAppBranch}
              versionList={versionList}
            ></Branch>
          </Modal>
          <Modal
            id='checkoutModal'
            dataTestId='checkoutModal'
            title={!resourceLock.userId ? "CHECKOUT" : "WARNING"}
            visible={lockVisible}
            className='common_modal'
            onCancel={() => {
              setLockVisible(false)
            }}
            unmountOnCancel={true}
            footer={{
              enable: false,
            }}
          >
            <>
            {
              !resourceLock.userId ?
                <>
                  <div className={style.modalMsg}>
                    Do you want to checkout ?
                  </div>
                  <div className={style.note}>
                    Note: This will prevent others from editing this resource until you commit
                  </div>
                </>
                :
                <>
                  <div className={style.modalMsg}>
                    <span className={style.modalHighlightedMsg}>{resourceLock.userName}</span> has currently checked out this resource
                  </div>
                  {
                    (
                      (isAssistCreation && canForceReleaseJourney) ||
                      (isFormCreation && canForceReleaseForm) || (isDmnCreation && canDMNForceRelease)
                    ) &&
                    <>
                      <div className={style.modalMsg}>
                        Do you want to force release ?
                      </div>
                      <div className={style.note}>
                        Note: This will revoke editing access from the currently checked out user.
                      </div>
                    </>
                  }
                </>
            }
            <ModalFooter 
              okClassName='tour_journey_checkout_ok'
              okText={!resourceLock.userId ? "CHECKOUT" : (
                (isAssistCreation && canForceReleaseJourney) ||
                (isFormCreation && canForceReleaseForm) || (isDmnCreation && canDMNForceRelease) || (isSoloCreation && canForceReleaseForm)
              ) ? "FORCE RELEASE" : "OK"}
              cancelText= {"CANCEL"}
              cancelCallback={() => {
                setLockVisible(false)
              }}
              okCallback={() => {
                const resource = {
                  resourceId: (isAssistCreation || isSoloCreation || isFormCreation || isDmnCreation) ? locationSplit[7] : locationSplit[6],
                  type: (isAssistCreation || isSoloCreation) ? 'Journey' : isDmnCreation ? "dmn" : 'Form',
                  resourceType: (isAssistCreation || isSoloCreation) ? 'bpmn' : isDmnCreation ? "dmn" : 'forms'
                }
                if (!resourceLock.userId) {
                  checkout(resource)
                } else if (
                  (isAssistCreation && canForceReleaseJourney) ||
                  (isFormCreation && canForceReleaseForm) || (isDmnCreation && canDMNForceRelease) || (isSoloCreation && canForceReleaseJourney)
                ) {
                  forceRelease(resource)
                } else {
                  setLockVisible(false)
                }
              }}
             />
            </>
          </Modal>
          <Modal
            id='commitModal'
            dataTestId='commitModal'
            title="COMMIT"
            visible={commitVisible}
            onCancel={() => {
              setCommitVisible(false)
            }}
            unmountOnCancel={true}
            footer={{
              enable: false,
            }}
          >
            {
              <>
                <div className={style.modalMsg}>
                  Do you want to save or discard your work?
                </div>
                <ModalFooter
                  okText={'SAVE & COMMIT'}
                  cancelText={"DISCARD & COMMIT"}
                  okCallback={commitChanges}
                  cancelCallback={discardChanges}
                  cancelClassName={'discard_btn'}
                />
              </>
            }
          </Modal>

          <Modal
            key={branchDetails?.branch_name}
            visible={showBranchDeleteModal}
            title="Warning"
            onCancel={() => setShowBranchDeleteModal(false)}
            deleteOptions={{
              type: "Branch",
              validateString: branchDetails?.branch_name
            }}
            footer={{
              OkButtonColor: "shadow-secondary",
              enable: true,
              okText: 'REMOVE',
              cancelText: 'CANCEL',
              onOk: () => handleDeleteBranch(branchDetails)
            }}
            unmountOnCancel={false}
          />
   
          {
            viewFormProperties &&
            <FormPropertiesModal data={tabData} dispatch={dispatch} formId={formId} assetsList={assetsList} setImportedAssets={setImportedAssets} importedAssets={importedAssets} viewFormProperties={viewFormProperties} setViewFormProperties={setViewFormProperties} />
          }
          {
            locationSplit[5] === 'solo' && (locationSplit[locationSplit.length - 1] === 'create') && <Modal
              id="confirmSoloPopup"
              dataTestId="soloPopup"
              title={<CustomPopupHeaderComponent setConfirmationSoloPopup={setConfirmationSoloPopup} />}
              unmountOnCancel={true}
              closable={false}
              visible={confirmationSoloPopup}
              onCancel={() => {
                backFunctionality && history.goBack()
                setConfirmationSoloPopup(false)
              }}
              footer={{
                enable: true,
                okText: "SAVE",
                cancelText: "CANCEL",
                onOk: () => {
                  handleSaveSolo();
                  setConfirmationSoloPopup(false);
                  backFunctionality && history.goBack();
                }
              }}
            > <div className={style.modalMsg}>
                Do you want to save your changes ?
              </div></Modal>
          }

          {
            locationSplit[5] === 'forms' && <Modal
              id="confirmFormPopup"
              dataTestId="confirmFormPopup"
              title={
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                  <p style={{marginBottom:0}}>SAVE</p>
                  <div style={{ cursor: 'pointer' }} onClick={() => { setConfirmationFormPopup(false) }}>X</div>
                </div>
              }
              closable={false}
              unmountOnCancel={true}
              visible={confirmationFormPopup}
              onCancel={() => {
                setConfirmationFormPopup(false)
                backFunctionality && history.goBack()
              }}
              footer={{
                enable: true,
                okText: "SAVE",
                cancelText: "CANCEL",
                onOk: () => {
                  formSave.sendMessage({ from: 'save' })
                  setConfirmationFormPopup(false);
                  isDraftForm && backFunctionality && history.goBack();
                }
              }}
            > <div className={style.modalMsg}>
                Do you want to save your changes ?
              </div></Modal>
          }
          <Modal
            id="downloadApp"
            unmountOnCancel
            visible={appDownloadModalVisibility}
            title={APP_DOWNLOAD_MODAL_TITLE}
            onCancel={() => setAppDownloadModalVisibility(false)}
            footer={{
              enable: true,
              okText: 'Download',
              cancelText: 'CANCEL',
              onOk: onDownloadAppConfirmation,
            }}
          >
            <div className={style.modalMsg}>
              <p>{APP_DOWNLOAD_MODAL_TEXT}</p>
            </div>
          </Modal>
        </div >
      </div >
    )
    :
    null
}

const AppType = (props: any) => {
  let style: Record<string, string> = {}
  let formattedValue = props.type === "a8chat" ? "A8 Chat" : props.type === "a8solo" ? "A8 Solo" : "A8 Flow"
  if(props.type === 'a8chat') {
    style.color = '#00B796';
    style.border = '1px solid #8BDECF';
    style.background = '#EEFFFC';
  }
  return <Tag style={{...style, fontSize: '13px', padding: '1px 8px'}} color={props.type === 'a8flow' ? 'blue' : 'orange'}>{formattedValue}</Tag>
}

const CustomPopupHeaderComponent = (props: any) =>
  <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
    <p>SAVE</p>
    <div style={{ cursor: 'pointer' }} onClick={() => { props.setConfirmationSoloPopup(false) }}>X</div>
  </div>

export default Header;
